import React, { FC } from 'react';

export const CheckIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.25 2.96875H13.1578C13.0047 2.96875 12.8594 3.03906 12.7656 3.15937L6.32345 11.3203L3.23438 7.40625C3.18765 7.34692 3.12809 7.29895 3.06017 7.26593C2.99224 7.23292 2.91772 7.21572 2.8422 7.21562H1.75001C1.64532 7.21562 1.58751 7.33594 1.65157 7.41719L5.93126 12.8391C6.13126 13.0922 6.51563 13.0922 6.7172 12.8391L14.3484 3.16875C14.4125 3.08906 14.3547 2.96875 14.25 2.96875Z" fill="#202734" />
  </svg>
);
